export default __webpack_public_path__ + "static/media/ficha-grade-1.00a91252.webp";